// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1561":"c1ec379ea32768be","2206":"d7bf778f4948f28f","2974":"42b93951da74302a","4218":"2e1d64b3a7dbf781","4268":"9d899c0b968d6c73"}[chunkId] + ".js";
};